import type { ReimbursementExtendedFields } from '../types/reimbursementFormTypes'

export function appendReimbursement3ScalarFieldsToFormData(
  fd: FormData,
  extended: ReimbursementExtendedFields,
): void {
  const payload: Record<string, unknown> = {}
  appendReimbursement3ScalarFields(payload, extended)
  for (const [key, value] of Object.entries(payload)) {
    if (value === undefined) continue
    fd.append(key, String(value))
  }
}

function yesNoToApiScalar(value: boolean | null | undefined): string | undefined {
  if (value === null || value === undefined) return undefined
  return value ? '1' : '0'
}

/** Maps 3.0 UI extended fields to `addLibertyDefault` scalar names. */
export function appendReimbursement3ScalarFields(
  payload: Record<string, unknown>,
  extended: ReimbursementExtendedFields,
): void {
  const unitTransfer = yesNoToApiScalar(extended.lease_modifications_at_move_in)
  if (unitTransfer !== undefined) payload.unit_transfer_after_movein = unitTransfer

  const noticeRequired = yesNoToApiScalar(extended.cares_act_applicable)
  if (noticeRequired !== undefined) payload.notice_required = noticeRequired

  const vacateBefore = yesNoToApiScalar(extended.skipped_during_eviction)
  if (vacateBefore !== undefined) payload.vacate_before_eviction_lawsuit_filed = vacateBefore

  const alternateCourt = yesNoToApiScalar(extended.alternate_court_document_applicable)
  if (alternateCourt !== undefined) payload.alternate_court_issued_document = alternateCourt

  const thirdPartyServices = yesNoToApiScalar(extended.using_third_party_eviction_services)
  if (thirdPartyServices !== undefined) {
    payload.using_third_party_eviction_services = thirdPartyServices
  }
  payload.third_party_servicer_name = extended.third_party_servicer_name.trim()

  const legalTeam = yesNoToApiScalar(extended.utilizing_legal_team_for_eviction)
  if (legalTeam !== undefined) payload.utilizing_legal_team_for_eviction = legalTeam

  const bankruptcy = yesNoToApiScalar(extended.bankruptcy_applicable)
  if (bankruptcy !== undefined) payload.bankruptcy_applicable = bankruptcy

  const appeal = yesNoToApiScalar(extended.appeal_applicable)
  if (appeal !== undefined) payload.appeal_applicable = appeal

  const paidIntoCourt = yesNoToApiScalar(extended.resident_paid_into_court)
  if (paidIntoCourt !== undefined) payload.resident_paid_into_court = paidIntoCourt

  const stipulation = yesNoToApiScalar(extended.stipulation_applicable)
  if (stipulation !== undefined) payload.stipulation_applicable = stipulation

  const defaultedStipulation = yesNoToApiScalar(extended.resident_defaulted_on_repayment)
  if (defaultedStipulation !== undefined) {
    payload.resident_defaulted_on_repayment = defaultedStipulation
  }
}
